export default "__VITE_ASSET__wVpWnhFc__"